"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelPopover = void 0;
const tslib_1 = require("tslib");
const catalog_messages_1 = require("@tableau/catalog-messages");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const CertificationPopover_1 = require("./certification/CertificationPopover");
const CustomPopover_1 = require("./custom/CustomPopover");
const LabelHelpers_1 = require("./LabelHelpers");
const SensitivityPopover_1 = require("./sensitivity/SensitivityPopover");
const Styles_1 = require("./Styles");
const WarningPopover_1 = require("./warning/WarningPopover");
const labelPlaceholder = (react_1.default.createElement("div", null,
    react_1.default.createElement(widgets_1.LoadingBone, null),
    react_1.default.createElement("div", null,
        react_1.default.createElement(widgets_1.LoadingBone, { style: { marginBottom: '1rem' } }),
        react_1.default.createElement("div", null,
            react_1.default.createElement(widgets_1.LoadingBone, null),
            react_1.default.createElement(widgets_1.LoadingBone, null)))));
function LabelPopoverInner(props) {
    switch (props.categoryType) {
        case 'certification':
            return react_1.default.createElement(CertificationPopover_1.CertificationPopover, Object.assign({}, props));
        case 'warning':
            return react_1.default.createElement(WarningPopover_1.WarningPopover, Object.assign({}, props));
        case 'sensitivity':
            return react_1.default.createElement(SensitivityPopover_1.SensitivityPopover, Object.assign({}, props));
        case 'custom':
            return react_1.default.createElement(CustomPopover_1.CustomPopover, Object.assign({}, props));
    }
}
function renderLabelPopoverLoaded(props) {
    if (props === undefined || props.kind === 'dehydrated') {
        return react_1.default.createElement(LabelMissing, null);
    }
    return (react_1.default.createElement(LabelHelpers_1.LabelsPopoverContext.Provider, { value: (0, LabelHelpers_1.buildLabelsPopoverContext)(props) },
        react_1.default.createElement(LabelPopoverInner, Object.assign({}, props))));
}
function LabelMissing() {
    return (react_1.default.createElement("div", null, catalog_messages_1.Messages.LabelRetrievalFailure()));
}
function LabelPopover({ resolved, loading }) {
    const isPending = loading || (resolved === null || resolved === void 0 ? void 0 : resolved.kind) === 'dehydrated' || !resolved;
    return (react_1.default.createElement(widgets_1.SkeletonLoaderWidget, { isPending: isPending, fallback: labelPlaceholder, style: Styles_1.LabelPopoverContentStyle }, renderLabelPopoverLoaded(resolved)));
}
exports.LabelPopover = LabelPopover;
//# sourceMappingURL=LabelPopover.js.map